import { NEWBUILDING_KPN_CHAT } from '../../constants/experiments';
import { TApplicationState } from '../../types/redux';
import { isAbUseExperimentGroup } from '../../utils/experiments';

export function selectNewbuildingKpnChatEnabled(state: TApplicationState): boolean {
  const { abUseExperiments } = state;

  const isExperimentEnabled = isAbUseExperimentGroup(abUseExperiments, NEWBUILDING_KPN_CHAT, 'B');

  const isKpnChatEnabled = state.newbuilding.kpnChatEnabled || false;

  return isKpnChatEnabled && isExperimentEnabled;
}
